import { Choice } from '../../../widgets/ChoiceSelector';
import Icon from '../../../widgets/Icons';
import { AdDataViewTypes } from '../../../types';
import { COMMON_DATA_FILTERS } from '../common/data_constants';
import { DataColumn, DataColumnTypes } from '../common/DataResultTable';
import {
  FilterDropdown,
  FilterDropdownTypes,
} from '../common/filterbar/AdditionalFilterBar';
import LightTooltip, {
  TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE,
} from '../../../widgets/LightTooltip';
import * as React from 'react';

export const VIEW_TYPE: { [key: string]: AdDataViewTypes } = {
  EVENT_CODE: 'event_code',
  USER: 'user',
  ORIGIN_USER: 'origin_user',
  DOMAIN: 'domain',
};

export const VIEW_CHOICES: Array<Choice> = [
  { value: VIEW_TYPE.EVENT_CODE, icon: Icon.Cog, label: 'Event Code' },
  { value: VIEW_TYPE.USER, icon: Icon.User, label: 'User' },
  { value: VIEW_TYPE.ORIGIN_USER, icon: Icon.UserTag, label: 'Origin User' },
  { value: VIEW_TYPE.DOMAIN, icon: Icon.Sensor, label: 'Domain' },
];

export const AD_DATA_FILTERS = {
  EVENT_CODE: 'event_code',
  USER: 'user',
  ORIGIN_USER: 'origin_user',
  DOMAIN: 'domain',
};

export const ORDERED_FILTER_KEYS = [
  // explicitly defined vs Object.values to manually set a sort order in the URL
  COMMON_DATA_FILTERS.START,
  COMMON_DATA_FILTERS.END,
  AD_DATA_FILTERS.EVENT_CODE,
  AD_DATA_FILTERS.USER,
  AD_DATA_FILTERS.ORIGIN_USER,
  AD_DATA_FILTERS.DOMAIN,
  COMMON_DATA_FILTERS.SORT,
];

export const SEEN_KEYS: Array<string> = [
  VIEW_TYPE.EVENT_CODE,
  VIEW_TYPE.USER,
  VIEW_TYPE.ORIGIN_USER,
  VIEW_TYPE.DOMAIN,
];

export const SORT_KEYS = [
  'event_code',
  '-event_code',
  'event_codes',
  '-event_codes',
  'user',
  '-user',
  'users',
  '-users',
  'origin_user',
  '-origin_user',
  'origin_users',
  '-origin_users',
  'domain',
  '-domain',
  'domains',
  '-domains',
  'events',
  '-events',
];

export const DEFAULT_SORT = '-events';

export const DATA_COLUMNS: Array<DataColumn> = [
  {
    type: DataColumnTypes.TEXT,
    field: 'desc',
    title: 'Event Description',
    sortable: false,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'event_codes',
    title: 'Event Codes',
    sortable: true,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'users',
    title: 'Users',
    sortable: true,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'origin_users',
    title: 'Origin Users',
    sortable: true,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'domains',
    title: 'Domains',
    sortable: true,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'events',
    title: 'Events',
    sortable: true,
  },
  {
    type: DataColumnTypes.SPARKLINE,
    field: 'eps',
    title: 'Events/sec',
    suffix: 'eps',
  },
];

export const FILTER_DROPDOWNS: Array<FilterDropdown> = [
  {
    type: FilterDropdownTypes.DATA,
    filterKey: AD_DATA_FILTERS.EVENT_CODE,
    label: 'Event Code',
    placeholder: 'All event codes',
    minWidth: 150,
    seenKey: 'event_code',
  },
  {
    type: FilterDropdownTypes.DATA,
    filterKey: AD_DATA_FILTERS.USER,
    label: 'User',
    placeholder: 'All users',
    minWidth: 210,
    seenKey: 'user',
  },
  {
    type: FilterDropdownTypes.DATA,
    filterKey: AD_DATA_FILTERS.ORIGIN_USER,
    label: 'Origin User',
    placeholder: 'All origin users',
    minWidth: 210,
    seenKey: 'origin_user',
    tooltip: (
      <LightTooltip
        size="xl"
        tooltip="The username of the user who initiated the event (ex. The admin user who unlocked a user account)"
        delay={TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE}
        placement="top"
      >
        <Icon.Question className="ml-2 text-muted" />
      </LightTooltip>
    ),
  },
  {
    type: FilterDropdownTypes.DATA,
    filterKey: AD_DATA_FILTERS.DOMAIN,
    label: 'Domain',
    placeholder: 'All domains',
    minWidth: 210,
    seenKey: 'domain',
  },
];
